// src/pages/BlogPost.jsx
import React from "react";
import { useParams, Link } from "react-router-dom";
import { BLOG_POSTS } from "./Blog";

export default function BlogPost() {
  const { slug } = useParams();
  const post = BLOG_POSTS.find((p) => p.slug === slug);

  if (!post) {
    return (
      <div style={{ padding: "5rem 2rem", textAlign: "center", color: "#fff", backgroundColor: "#141414", minHeight: "100vh" }}>
        <h2 style={{ fontSize: "2rem", marginBottom: "1rem" }}>Article Not Found</h2>
        <Link to="/blog" style={{ color: "#3b82f6", textDecoration: "none" }}>Return to Blog Index</Link>
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: "#141414", minHeight: "100vh", padding: "4rem 1.5rem" }}>
      <article style={{ maxWidth: "750px", margin: "0 auto", color: "#fff", lineHeight: "1.8", fontFamily: "sans-serif" }}>
        <Link to="/blog" style={{ color: "#888", textDecoration: "none", display: "inline-block", marginBottom: "2rem", fontWeight: "500" }}>← Back to Blog</Link>
        <h1 style={{ fontSize: "2.5rem", marginBottom: "0.5rem", lineHeight: "1.2", fontWeight: "700" }}>{post.title}</h1>
        <time style={{ color: "#555", display: "block", marginBottom: "2.5rem", fontWeight: "500" }}>{post.date}</time>
        <div style={{ fontSize: "1.1rem", color: "#e5e7eb", whiteSpace: "pre-line", textAlign: "justify" }}>
          {post.content}
        </div>
      </article>
    </div>
  );
}
